import { gql } from '@apollo/client';

export const fetchSearchSupportIssues = gql`
  query fetchSearchSupportIssues($searchParam: SupportIssueSearchParams, $searchOptions: SearchOptions) {
    fetchSearchSupportIssues(searchParam: $searchParam, searchOptions: $searchOptions) {
      totalCount
      edges {
        cursor
        node {
          issueKey
          summary
          currentStatus
          updatedTimestamp
          reporterEmailAddress
        }
      }
    }
  }
`;
